<template>
  <ListView
    modelName="ProjectItem"
    perm="sales.menu_project_item"
    svg="icon_side_case"     
    :items.sync="items"
    :params.sync="params"
    title="menu_project_item"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="ProjectItem"
    :gridCaptions="['状態','ワークフロー', '案件番号', '案件名称', '得意先', '開始日', '初回保存日', '初回保存者', '最終更新日', '最終更新者']"
    :gridWidths="[100, 180, 150, 150, 150,150, 150,  150, 150, 150]"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    :comparer="(a,b)=>a.projectItemNo == b.projectItemNo"   
    borderColor="#E35F71"
    backColor="#FFF1F3"                     
    tooltip="案件を登録すると受注と発注をグループ化できます。"
    :popup="popup"    
  >
    <!-- 明細項目の配置 -->
    <GridItem slot="grid0" slot-scope="{ item }"><Badge :value="item.state" list="projectItemStatus"/></GridItem>
    <GridItem slot="grid1" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow" :perm="$refs.mainList.perm+'.approve'"/></GridItem>    
    <GridItem slot="grid2" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.projectItemNo }}</GridItem>
    <GridItem slot="grid3" slot-scope="{ item }">{{ item.name }}</GridItem>
    <GridItem slot="grid4" slot-scope="{ item }">{{ item.counterpart ? item.counterpart.name : '' }}</GridItem>
    <GridItem slot="grid5" slot-scope="{ item }">{{ item.startDate | date }}</GridItem>    
    <GridItem slot="grid6" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem slot="grid7" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem slot="grid8" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem slot="grid9" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }"><ListViewMenuBar :listView="listView"/></template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView">
        <FilterBox title="案件番号" :value.sync="params.projectItemNo" @click="handler" />
        <FilterBox title="案件名称" :value.sync="params.name" @click="handler" />
        <AtcCounterpart title="得意先" :value.sync="params.counterpart" :needsCustomer="true" @changed="handler" />        
        <Calendar title="開始日(From)" :value.sync="params.startDateFrom" :deletable="true" @changed="handler"/>
        <Calendar title="開始日(To)" :value.sync="params.startDateTo" :deletable="true" @changed="handler"/>        
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />          
        <ComboBox title="状態" :value.sync="params.state" list="projectItemStatus" @changed="handler" />        
      </Search>
    </template>
    <!-- エディタの配置 -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','受注伝票','発注伝票','出荷伝票','入荷伝票','案件在庫','ワークフロー','更新履歴']" :tabTooltips="[null,null,null,null]">
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">              
              <TextBox title="案件番号" :editor="editor" :value.sync="item.projectItemNo" :enabled="false" />
              <TextBox title="案件名称" :editor="editor" :value.sync="item.name" :required="true" length="50"/>
              <AtcCounterpart title="得意先" :value.sync="item.counterpart" :editor="editor" :needsCustomer="true" :required="true"/>
              <Calendar title="開始日" :value.sync="item.startDate" :editor="editor" :required="true"/>  
              <!-- 通貨小数点は0固定 -->
              <NumericBox title="粗利" :value.sync="grossProfit" :editor="editor" :enabled="false" :decimals="0" tooltip=""/>                          
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="最後に更新した日付が表示されます。" />                      
              <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_projectItem" :required="$api.perms.hasWorkflow('projectItem')" :enabled="$api.perms.hasWorkflow('projectItem') && $api.perms.isEntryStatus(item)" :nullValue="0"  tooltip="案件管理用のワークフローを指定します。"/>
              <TextBox title="状態" :value="$api.perms.getWorkflowStateLabel(item)" :enabled="false" tooltip="現在のワークフローの状態が表示されています。"/>                   
            </template>
          </EditPanel>
        </template>
        <!-- 受注タブ -->
        <template slot="tab1" slot-scope="{ item,editor}">
          <GrdVoucherItem :voucherNo="item.projectItemNo" :voucherType="voucherTypes.ProjectItem" :voucherItemType="voucherTypes.SalesOrder" ref="salesOrder" :showCheckBox="false" :comparer="(a,b)=>a.auditNo == b.auditNo" @afterVoucherNoChanged="afterVoucherNoChanged(voucherTypes.SalesOrder)">
              <PopupEditor slot="popupEditor" slot-scope="{parent}" v-model="parent.showEditor" title="受注伝票" mode="editor" :isInsertMode="false" @closing="args=>{parent.replaceItem(args.target);$refs.mainList.reloadSelected();onPopupClosing(voucherTypes.SalesOrder);}">
                <SalesOrder slot-scope={popup} :popup="popup" :orderNo="parent.editItem ? parent.editItem.orderNo: null"/>
              </PopupEditor>                
          </GrdVoucherItem>
        </template>                    
        <!-- 発注タブ -->
        <template slot="tab2" slot-scope="{ item,editor}">
          <GrdVoucherItem :voucherNo="item.projectItemNo" :voucherType="voucherTypes.ProjectItem" :voucherItemType="voucherTypes.PurchaseOrder" ref="purchaseOrder" :showCheckBox="false" :comparer="(a,b)=>a.auditNo == b.auditNo" @afterVoucherNoChanged="afterVoucherNoChanged(voucherTypes.PurchaseOrder)">
              <PopupEditor slot="popupEditor" slot-scope="{parent}" v-model="parent.showEditor" title="発注伝票" mode="editor" :isInsertMode="false" @closing="args=>{parent.replaceItem(args.target);$refs.mainList.reloadSelected();onPopupClosing(voucherTypes.PurchaseOrder);}">
                <PurchaseOrder slot-scope={popup} :popup="popup" :orderNo="parent.editItem ? parent.editItem.orderNo: null"/>
              </PopupEditor>                
          </GrdVoucherItem>
        </template>       
        <!-- 出荷タブ -->
        <template slot="tab3" slot-scope="{ item,editor}">
          <GrdVoucherItem :voucherNo="item.projectItemNo" :voucherType="voucherTypes.ProjectItem" :voucherItemType="voucherTypes.SalesDelivery" ref="salesDelivery" :showCheckBox="false" :comparer="(a,b)=>a.auditNo == b.auditNo">
              <PopupEditor slot="popupEditor" slot-scope="{parent}" v-model="parent.showEditor" title="出荷伝票" mode="editor" :isInsertMode="false" @closing="args=>{parent.replaceItem(args.target);$refs.mainList.reloadSelected();onPopupClosing(voucherTypes.SalesDelivery);}">
                <SalesDelivery slot-scope={popup} :popup="popup" :deliveryNo="parent.editItem ? parent.editItem.deliveryNo: null"/>
              </PopupEditor>                
          </GrdVoucherItem>
        </template>     
        <!-- 入荷タブ -->
        <template slot="tab4" slot-scope="{ item,editor}">
          <GrdVoucherItem :voucherNo="item.projectItemNo" :voucherType="voucherTypes.ProjectItem" :voucherItemType="voucherTypes.PurchaseDelivery" ref="purchaseDelivery" :showCheckBox="false" :comparer="(a,b)=>a.auditNo == b.auditNo">
              <PopupEditor slot="popupEditor" slot-scope="{parent}" v-model="parent.showEditor" title="入荷伝票" mode="editor" :isInsertMode="false" @closing="args=>{parent.replaceItem(args.target);$refs.mainList.reloadSelected();onPopupClosing(voucherTypes.PurchaseDelivery);}">
                <PurchaseDelivery slot-scope={popup} :popup="popup" :deliveryNo="parent.editItem ? parent.editItem.deliveryNo: null"/>
              </PopupEditor>                
          </GrdVoucherItem>
        </template>                             
        <!-- 在庫タブ -->
        <template slot="tab5" slot-scope="{ item,editor}">
          <GrdVoucherItem :voucherNo="item.projectItemNo" :voucherType="voucherTypes.ProjectItem" :voucherItemType="voucherTypes.StockBalance" ref="stockBalance" :showCheckBox="false" :comparer="(a,b)=>a.auditNo == b.auditNo">      
          </GrdVoucherItem>
        </template>                                 
        <!-- ワークフロータブ -->
        <template slot="tab6" slot-scope="{ item, editor }">
          <MessageList class="cx_matter_message" :item="item" :editor="editor" />
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab7" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
      </Editor>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import { voucherTypes } from '@/tenant/common/All';

@Component
export default class CategoryView extends Vue {
  public items: Common.ProjectItem[] = new Array(0);
  public params: Common.ProjectItemQuery = new Common.ProjectItemQuery();
  public importQuery = new Common.ImportQuery('案件', 'ProjectItem');
  public exportQuery = new Common.ExportQuery('案件', this.params);
  @Prop() public projectItemNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  

  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'projectItemNo', text: '案件番号' },
    { value: 'name', text: '案件名称' },
    { value: 'counterpart', text: '得意先' },    
    { value: 'startDate', text: '開始日' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },    
  ];
  public voucherTypes = Common.voucherTypes;
  
  public created() {
    // 検索条件を設定する
    if(this.projectItemNo) {
      this.params.projectItemNo = this.projectItemNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
      this.params.state = this.$api.onlyOpen ? Common.ProjectItemStatus.Active : null;
    }
  }

  public async onCreate(obj: Common.ProjectItem) {
    const workflows = this.$api.formatter.getOptions('workflow_projectItem');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public onPopupClosing(voucherType : Common.voucherTypes){
    if (voucherType != Common.voucherTypes.SalesOrder) (this.$refs.salesOrder as Components.GrdVoucherItem).onVoucherNoChanged();
    if (voucherType != Common.voucherTypes.SalesDelivery) (this.$refs.salesDelivery as Components.GrdVoucherItem).onVoucherNoChanged();
    if (voucherType != Common.voucherTypes.PurchaseOrder) (this.$refs.purchaseOrder as Components.GrdVoucherItem).onVoucherNoChanged();
    if (voucherType != Common.voucherTypes.PurchaseDelivery) (this.$refs.purchaseDelivery as Components.GrdVoucherItem).onVoucherNoChanged();
    (this.$refs.stockBalance as Components.GrdVoucherItem).onVoucherNoChanged();            
  }

  // 粗利計算
  public grossProfit: number = 0;
  public salesOrderAmount: number = 0;
  public purchaseOrderAmount: number = 0;  
  public afterVoucherNoChanged(voucherType : Common.voucherTypes){
    if (voucherType == Common.voucherTypes.SalesOrder) {
      this.salesOrderAmount = 0;
      var items =  (this.$refs.salesOrder as Components.GrdVoucherItem).items as Common.Order[];
      items.forEach(obj => this.salesOrderAmount += obj.amountFC);
    } else if (voucherType == Common.voucherTypes.PurchaseOrder) {
      this.purchaseOrderAmount = 0;
      var items =  (this.$refs.purchaseOrder as Components.GrdVoucherItem).items as Common.Order[];
      items.forEach(obj => this.purchaseOrderAmount += obj.amountFC);
    }
    this.grossProfit = this.salesOrderAmount - this.purchaseOrderAmount;
  }  
}
</script>
